import { ButtonPrimary } from "components/Atoms/Button";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { DetailSidePanel } from "../DetailSidePanel";
import { FreeFieldPermissionProfileSidePanelDetails } from "./FreeFieldPermissionProfileSidePanelDetails";
import { RightClickMenu } from "components/RightClickMenu/RightClickMenuContext";
import { rightMenuForSidePanel } from "components/RightClickMenu/rightClickMenuUtils";

export interface FreeFieldPermissionProfileSidePanelProps {
  freeFieldPermissionProfileId: number
  environment: server.dto.Environments
  trigger: JSX.Element
}

export const FreeFieldPermissionProfileSidePanel = (props: FreeFieldPermissionProfileSidePanelProps) => {
  return <DetailSidePanel
    detailUrl={routes.freeFieldProfile_Detail(props.environment, props.freeFieldPermissionProfileId).absolute}
    apiCall={() => window.CoreApi.FreeFieldProfile.GetSidePanelData(props.freeFieldPermissionProfileId)}
    apiKey="freeFieldProfile"
    entityId={props.freeFieldPermissionProfileId}
    title={RESX.FreeField.FreeFieldPermissionProfile}
    footerContent={profile => <>
      <ButtonPrimary href={routes.freeFieldProfile_Detail(profile.profile.environment, props.freeFieldPermissionProfileId).absolute} label={RESX.Buttons.DetailView} />
    </>}
    trigger={<RightClickMenu menuItems={rightMenuForSidePanel(routes.freeFieldProfile_Detail(props.environment, props.freeFieldPermissionProfileId).absolute)}>{props.trigger}</RightClickMenu>}
  >
    {(data) => <FreeFieldPermissionProfileSidePanelDetails
      data={data}
      environment={props.environment}
    />}
  </DetailSidePanel>
}